export default __webpack_public_path__ + "static/media/MM.1a46e1f8.jpg";